import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import Vuex from 'vuex';
import store from './store';
import ICS from 'vue-ics';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(ICS);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
